import React from "react";
import "../css/ComprarPuntos.css";


interface Props {
  user: any;
}


const ComprarPuntos: React.FC<Props> = ({ user }) => {

  const comprar = async (idPromo: number) => {
    try {
      const response = await fetch("https://prediccionmundial.com/api/pagos/crear-preferencia", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idPromo,
          idUsuario: user.id
        })
      });

      const data = await response.json();

      if (!data.init_point) {
        alert("Error al crear la preferencia");
        return;
      }

      window.location.href = data.init_point;

    } catch (error) {
      console.error("Error comprando:", error);
    }
  };

  return (
    <div className="puntos-container">

      <h2 className="puntos-title">Comprar Puntos</h2>

      <div className="puntos-grid">

        {/* PLAN 1 */}
        <div className="card-puntos card-promo1">

          <div className="card-overlay">
            <div className="card-overlay-inner">

              <div className="card-header">
                <h3 className="card-title">Pack Inicial</h3>
                <span className="badge-plan">Popular</span>
              </div>

              <div className="card-info-box">

                <div className="puntos-cantidad">
                  500 puntos
                </div>

                <p className="puntos-desc">
                  Ideal para empezar a apostar en varios partidos.
                </p>

              </div>
              <div className="precio-box">

                <div className="precio-usd">
                  5 USD
                </div>

                <div className="precio-ars">
                  ≈ $5.500 ARS
                </div>
               
              </div>

              <button
                className="btn-comprar"
                onClick={() => comprar(1)}
              >
                Comprar ahora
              </button>
               <div className="pago-seguro">
                Pago seguro con Mercado Pago
                </div>

            </div>
          </div>

        </div>


        {/* PLAN 2 */}
        <div className="card-puntos card-promo2">

          <div className="card-overlay">
            <div className="card-overlay-inner">

              <div className="card-header">
                <h3 className="card-title">Pack Pro</h3>
                <span className="badge-plan destacado">Recomendado</span>
              </div>

              <div className="card-info-box">

                <div className="puntos-cantidad">
                  1200 puntos
                </div>

                <p className="puntos-desc">
                  Más puntos para dominar la competencia.
                </p>

                
              </div>

                 <div className="precio-box">

                  <div className="precio-usd">
                    10 USD
                  </div>

                  <div className="precio-ars">
                    ≈ $11.000 ARS
                  </div>
                 

              </div>

              <button
                className="btn-comprar destacado"
                onClick={() => comprar(2)}
              >
                Comprar ahora
              </button>
               <div className="pago-seguro">
                Pago seguro con Mercado Pago
                </div>

            </div>
          </div>

        </div>


        {/* PLAN 3 */}
        <div className="card-puntos card-promo3">

          <div className="card-overlay">
            <div className="card-overlay-inner">

              <div className="card-header">
                <h3 className="card-title">Pack Leyenda</h3>
                <span className="badge-plan premium">Premium</span>
              </div>

              <div className="card-info-box">

                <div className="puntos-cantidad">
                  3000 puntos
                </div>

                <p className="puntos-desc">
                  Para jugadores que quieren dominar el torneo.
                </p>

              </div>

              <div className="precio-box">

                  <div className="precio-usd">
                    15 USD
                  </div>

                  <div className="precio-ars">
                    ≈ $16.500 ARS
                  </div>
                

              </div>

              <button
                className="btn-comprar premium"
                onClick={() => comprar(3)}
              >
                Comprar ahora
              </button>
                <div className="pago-seguro">
                Pago seguro con Mercado Pago
                </div>

            </div>
          </div>

        </div>

      </div>
    </div>
    
  );
};

export default ComprarPuntos;